import { createContext } from "react";

export type ChartTooltipCardContextType<T = any> = React.FC<T>;

const ChartTooltipCardContext = createContext<ChartTooltipCardContextType | undefined>(undefined);
ChartTooltipCardContext.displayName = "ChartTooltipCardContext";

export default ChartTooltipCardContext;
